import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Briefcase01 = function Briefcase01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 7c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C13.395 3 12.93 3 12 3s-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C8 5.605 8 6.07 8 7M5.2 21h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 19.4802 22 18.9201 22 17.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 7 19.9201 7 18.8 7H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 8.5198 2 9.08 2 10.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 21 4.08 21 5.2 21"
    })
  }));
};
export default Briefcase01;